const apiUrl = process.env.REACT_APP_API_URL;
export const GetUsuarisIdAulaIdJutgeNotes = async (id_user : string, id_aula: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/usuaris/${id_user}/aula/${id_aula}/jutge/notes`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
